import { useState, useEffect } from 'react';
import { Channel as StreamChatChannel } from 'stream-chat';

interface ChatMember {
  id: string;
  name?: string;
}

interface UseEventChatMembersReturn {
  memberCount: number;
  members: ChatMember[];
}

export function useEventChatMembers(channel: StreamChatChannel | null): UseEventChatMembersReturn {
  const [memberCount, setMemberCount] = useState(0);
  const [members, setMembers] = useState<ChatMember[]>([]);

  useEffect(() => {
    if (!channel) {
      return;
    }

    const updateMemberState = () => {
      const watchers = Object.values(channel.state?.watchers || {}) as ChatMember[];
      const count = channel.state?.watcher_count || 0;

      setMembers(watchers);
      setMemberCount(count);
    };

    updateMemberState();

    const handleEvent = (event: { type?: string }) => {
      if (
        event.type === 'user.watching.start' ||
        event.type === 'user.watching.stop' ||
        event.type === 'user.presence.changed'
      ) {
        updateMemberState();
      }
    };

    channel.on(handleEvent);

    return () => {
      channel.off(handleEvent);
    };
  }, [channel]);

  return {
    memberCount,
    members,
  };
}
